import React, {ChangeEvent, useEffect, useState} from "react";
import styles from './rightMenu.module.scss';
import {HorizontalTabs} from "../../../../../com/horizontalTabs/horizontalTabs";
import {TABS_LIST_PROMOTIONS_ITEMS_UNLINK} from "../../../../../globals/Contants";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";
import {SearchBar} from "../../../../../com/searchBar/searchBar";
import {useDispatch} from "react-redux";
import {
    changeSearchTermForUnlinkedPromotionsItems,
    deleteItemsFromFlyer, deletePromosFromFlyer
} from "../../../../../store/actionCreators/promotionsItemsCreators";
import {UnlinkTablesForPromosItemsScreen} from "./unlinkTablesForPromosItemsScreen/unlinkTablesForPromosItemsScreen";
import {PromoDto, PromoItemsDto} from "../../../../../dtos";
import {Box, Button, Checkbox, Typography} from "@mui/material";
import {ReactComponent as TrashIcon} from "../../../../../assets/promos&items/delete_icon.svg";
import {makeStyles} from "@mui/styles";
import StatusPopup, {StatusPopupType} from "../../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../../pages/getSetttingsForPopup";

const useStyles = makeStyles(() => ({
    unlinkSelectedPromosBtn: {
        '&.Mui-disabled': {
            opacity: `0.5`
        }
    }
}))

interface Props {
    onChangeSelectedPromos: (promo: PromoDto, event: React.MouseEvent<HTMLElement>, index: number) => void;
    onChangeSelectedItems: (item: PromoItemsDto, e: React.MouseEvent<HTMLElement>, isAllSelected?: boolean) => void;
    targetItems: PromoItemsDto[];
    setTargetItems: (promoItems: PromoItemsDto[]) => void;
    targetUnlinkedPromos: PromoDto[];
    setTargetUnlinkedPromos: (promos: PromoDto[]) => void;
}

export const FlyerPromoItemsRightMenu = (props: Props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const [searchValue, changeValue] = useState<string>('');
    const [isModalPopup, changeModalStatus] = useState(false);
    useEffect(() => {
        return () => {
            dispatch(changeSearchTermForUnlinkedPromotionsItems({
                searchTermForUnlinkedItems: '',
                searchTermForUnlinkedPromotions: ''
            }))
        }
    }, [])

    useEffect(() => {
        if (promotionsItemsState.activeTab === "Promotions") {
            changeValue(promotionsItemsState.searchTerm.searchTermForUnlinkedPromotions)
        } else {
            changeValue(promotionsItemsState.searchTerm.searchTermForUnlinkedItems)
        }
    }, [promotionsItemsState.searchTerm, promotionsItemsState.activeTab]);

    const onSearchEnteredTerm = (event: any) => {
        event.preventDefault();
        if (promotionsItemsState.activeTab === "Promotions") {
            dispatch(changeSearchTermForUnlinkedPromotionsItems({
                ...promotionsItemsState.searchTerm,
                searchTermForUnlinkedPromotions: searchValue
            }))
        } else {
            dispatch(changeSearchTermForUnlinkedPromotionsItems({
                ...promotionsItemsState.searchTerm,
                searchTermForUnlinkedItems: searchValue
            }))
        }
    }

    const onChangeSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        changeValue(value);
    }
    const clearSearch = () => {
        if (promotionsItemsState.activeTab === "Promotions") {
            dispatch(changeSearchTermForUnlinkedPromotionsItems({
                ...promotionsItemsState.searchTerm,
                searchTermForUnlinkedPromotions: ''
            }))
        } else {
            dispatch(changeSearchTermForUnlinkedPromotionsItems({
                ...promotionsItemsState.searchTerm,
                searchTermForUnlinkedItems: ''
            }))
        }
    }

    const selectAllUnlinked = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (promotionsItemsState.activeTab === "Promotions") {
            // toggleSelectAllUnlinkedPromos(!isSelectAllUnlinkedPromos);
            const isSelected = e.target.checked;
            if (isSelected) {
                props.setTargetUnlinkedPromos([...promotionsItemsState.unlinkPromos])
            } else {
                props.setTargetUnlinkedPromos([])
            }
        } else {
            const isSelected = e.target.checked;
            if (isSelected) {
                props.setTargetItems([...promotionsItemsState.unlinkItems])
            } else {
                props.setTargetItems([])
            }
        }
    }
    const deleteSelectedPromosOrItems = () => {
        if (promotionsItemsState.activeTab === "Promotions") {
            changeModalStatus(true);
        } else {
            const targetItemsIds = [...props.targetItems!].map((item: PromoItemsDto) => item.fpiRecId!);
            dispatch(deleteItemsFromFlyer(targetItemsIds, flyerDetailsState.flyRecId!))
        }
    }

    const onDeleteSelectedPromotions = (isDeleteWithItem?: boolean) => {
        const selectedPromosIds = props.targetUnlinkedPromos.map((promo: PromoDto): number => promo.flrRecId!)
        dispatch(deletePromosFromFlyer(selectedPromosIds, isDeleteWithItem!, flyerDetailsState.flyRecId!));
        changeModalStatus(false);
    }


    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: promotionsItemsState.activeTab === 'Promotions' ? 'deletePromosFromFlyer' : 'deleteItemsFromFlyer',
        confirmOnClick: {
            deletePromosItemsFromFlyer: onDeleteSelectedPromotions
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <div className={styles.header_for_right_menu}>
            <HorizontalTabs tabs={TABS_LIST_PROMOTIONS_ITEMS_UNLINK}/>
            <Box sx={{
                display: `flex`,
                alignItems: `center`,
            }}>
                <SearchBar onSearchEnteredTerm={onSearchEnteredTerm}
                           onChangeSearchValue={onChangeSearchValue}
                           clearSearch={clearSearch}
                    // searchValue={promotionsItemsState.activeTab === "Promotions" ? searchValue.forPromotions : searchValue.forItems}/>
                           searchValue={searchValue}/>
                <Box sx={{
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    width: `50%`
                }}>
                    <Box sx={{
                        display: `flex`,
                        alignItems: `center`,
                        backgroundColor: `white`,
                        justifyContent: `center`,
                        padding: `2px 5px`,
                    }}>
                        <Checkbox
                            checked={
                                promotionsItemsState.activeTab === "Promotions" ?
                                    props.targetUnlinkedPromos.length > 0 && (props.targetUnlinkedPromos.length === promotionsItemsState.unlinkPromos.length) :
                                    props.targetItems.length > 0 && (props.targetItems.length === promotionsItemsState.unlinkItems.length)
                            }
                            onChange={selectAllUnlinked}
                            // checkedIcon={<CheckedIcon />}
                            inputProps={{'aria-label': 'controlled'}}
                            sx={{
                                padding: `0`,
                                marginRight: `5px`
                            }}
                        />
                        <Typography sx={{
                            marginRight: `5px`,
                            lineHeight: `15px`,
                        }}>
                            Select all
                        </Typography>
                        <Button
                            className={classes.unlinkSelectedPromosBtn}
                            disabled={promotionsItemsState.activeTab === "Promotions" ? props.targetUnlinkedPromos.length === 0 : props.targetItems.length === 0}
                            sx={{
                                marginLeft: `5px`
                            }}
                            onClick={deleteSelectedPromosOrItems}
                        >
                            <TrashIcon/>
                        </Button>
                    </Box>
                </Box>
            </Box>
            <UnlinkTablesForPromosItemsScreen
                onChangeSelectedPromos={props.onChangeSelectedPromos}
                onChangeSelectedItems={props.onChangeSelectedItems}
                targetItems={props.targetItems}
                targetUnlinkedPromos={props.targetUnlinkedPromos}
            />
            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isModalPopup}
                handleClose={() => changeModalStatus(false)}
            />
            }
        </div>
    )
}